import { render, staticRenderFns } from "./SwapProviderMentions.vue?vue&type=template&id=a5ae174a&scoped=true"
import script from "./SwapProviderMentions.vue?vue&type=script&lang=js"
export * from "./SwapProviderMentions.vue?vue&type=script&lang=js"
import style0 from "./SwapProviderMentions.vue?vue&type=style&index=0&id=a5ae174a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ae174a",
  null
  
)

export default component.exports